module.exports = __webpack_public_path__ + "img/banner_1.6df67520.jpg";